// import {
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   Button,
//   CircularProgress,
//   Typography,
// } from "@mui/material";
// import { useEffect, useState } from "react";
// import { useMutation } from "react-query";
// import { getPriorAprovals, submitPriorApproval } from "../../services";
// import { useParams } from "react-router-dom";
// import CustomTableBody from "../../../utilis/component/CustomTableBody";
// import { PriorApprovalSubmitParamsType } from "./types";
// import { clinicId, user } from "../../../constants";
// import moment from "moment";
// import usePopup from "../../../hooks/usePopup";

function PriorApproval() {
  // const { encounterId } = useParams();
  // const { showSnackbar, CustomModal } = usePopup();
  // const [open, setOpen] = useState<boolean>(false);
  // const [submissionResponse, setSubmissionResponse] = useState<any>(null);
  // const {
  //   mutate: fetchAprovals,
  //   isLoading: fetchLoading,
  //   data,
  // } = useMutation(getPriorAprovals);

  // const { mutate: savePriorApproval, isLoading: submitLoading } = useMutation(
  //   submitPriorApproval,
  //   {
  //     onSuccess: (result) => {
  //       if (result.responseIndicator == "success") {
  //         const submitRsponse = result?.response[0] || null;
  //         if(Boolean(submitRsponse)){
  //           if(submitRsponse?.Success){
  //             showSnackbar({
  //               message: submitRsponse?.UserMessage,
  //               open: true,
  //               variant: "success",
  //               duration: 2000,
  //             });
  //           }else{
  //             setSubmissionResponse(submitRsponse);
  //             setOpen(Boolean(submitRsponse));
  //           }
  //         }

  //       } else {
  //         showSnackbar({
  //           message: result.responseMessage,
  //           open: true,
  //           variant: "warning",
  //           duration: 2000,
  //         });
  //       }
  //     },
  //   }
  // );

  // const handlePriorApprovalSubmit = () => {
  //   const approvalArray: PriorApprovalSubmitParamsType[] = [];
  //   data?.response?.forEach((item) => {
  //     const obj: PriorApprovalSubmitParamsType = {
  //       priorAuthId: null,
  //       approvalCode: "N/A",
  //       authType: "authType",
  //       cancelDate: null,
  //       clinicId: clinicId,
  //       clinician: user.emp_name,
  //       clinicianCode: item.clinicianCode,
  //       comments: "N/A",
  //       createdId: user.clinicianID,
  //       emiratesId: item.emiratesId,
  //       encFacilityId: item.encFacilityId,
  //       encType: "OP",
  //       endDate: null,
  //       idenfyWproce: 0,
  //       ip: "192.168.1.1",
  //       memberId: item.memberId,
  //       modifiedId: 1,
  //       modifiedDate: null,
  //       payerId: item.payerId,
  //       providerId: item.encFacilityId,
  //       result: "result",
  //       startDate: moment().toISOString(),
  //       status: 1,
  //       transDate: moment().toISOString(),
  //       uniqAuthId: null,
  //       visitNo: parseInt(encounterId as string),
  //       encounterId: parseInt(encounterId as string),
  //       dispositionFlag: 1,
  //       postOfficeId:item?.postOfficeId || 0
  //     };
  //     approvalArray.push(obj);
  //   });
  //   savePriorApproval(approvalArray);
  // };
  // useEffect(() => {
  //   fetchAprovals(encounterId as string);
  // }, []);
  return (
    <div>
      {/* <CustomModal
        title={submissionResponse?.Success ? "Success" : "Error"}
        open={open}
        setOpen={setOpen}
      >
        <div className="flex flex-col gap-2 overflow-y-auto p-4">
          <Typography
            fontSize={"1rem"}
            color={submissionResponse?.Success ? "success" : "error"}
            fontWeight={600}
            sx={{
              maxWidth: "50vw",
              overflowWrap: "break-word",
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
            }}
          >
            {submissionResponse?.UserMessage}
          </Typography>
          <div className="min-h-[55dvh] max-h-[55dvh]">
            {submissionResponse?.Error?.map((e: any,index:number) => (
              <div className="flex gap-2">
                <span>{index+1}. </span>
                <Typography
                  sx={{
                    maxWidth: "50vw",
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {e.ErrorText}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </CustomModal>

      <TableContainer className="min-h-[60dvh] max-h-[60dvh] overflow-y-auto">
        <Table size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              {heading.map((title, index) => (
                <TableCell key={`heading${index}`}>
                  <strong>{title}</strong>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <CustomTableBody
            totalSpan={{ col: heading.length, row: 10 }}
            alert={"No records"}
            dataLoading={fetchLoading}
            isData={Boolean(data?.response.length)}
          >
            {data?.response.map((item, index) => (
              <TableRow key={`tablebody${index}`}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.cpt_code}</TableCell>
                <TableCell>{item.unitRate}</TableCell>
                <TableCell>{item.qty}</TableCell>
                <TableCell>{item.amt}</TableCell>
              </TableRow>
            ))}
          </CustomTableBody>
        </Table>
      </TableContainer>
      <div className="flex justify-end p-2">
        <Button
          onClick={handlePriorApprovalSubmit}
          disabled={submitLoading || !Boolean(data?.response.length)}
          endIcon={submitLoading && <CircularProgress size={18} />}
        >
          Submit
        </Button>
      </div> */}
    </div>
  );
}

export default PriorApproval;
// const heading = [" SL NO.", "CODE", "UNIT RATE", "QUANTITY", "AMOUNT"];
